(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.boundUpdateHeaderMetrics = () => {
        this.setHeaderHeight();
        this.refreshHeaderBounds();
        this.setHeaderStickyOffset();
      };

      this.boundUpdateHeaderMetrics();

      const onBreakpointChange = () => this.boundUpdateHeaderMetrics();
      window.matchMedia('(max-width: 990px)').addEventListener('change', onBreakpointChange);
      this._onBreakpointChange = onBreakpointChange;

      window.addEventListener('resize', this.boundUpdateHeaderMetrics);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.refreshHeaderBounds());
      });

      this._headerResizeObserver = new ResizeObserver(() => this.boundUpdateHeaderMetrics());
      this._headerResizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderStickyOffset() {
      const stickyOffset = this.getTopOverlayOffset();
      if (this._lastStickyOffset === stickyOffset) return;
      this._lastStickyOffset = stickyOffset;
      document.documentElement.style.setProperty('--header-sticky-offset', `${stickyOffset}px`);
    }

    getTopOverlayOffset() {
      let maxOverlayBottom = 0;
      const samplePoints = [1, Math.floor(window.innerWidth / 2), Math.max(window.innerWidth - 2, 1)];
      samplePoints.forEach((x) => {
        const stack = document.elementsFromPoint(x, 1);
        stack.forEach((element) => {
          if (this.header.contains(element) || element.closest('.section-header')) return;
          const styles = window.getComputedStyle(element);
          if ((styles.position === 'fixed' || styles.position === 'sticky') && styles.display !== 'none' && styles.visibility !== 'hidden') {
            const rect = element.getBoundingClientRect();
            if (rect.height > 0 && rect.top <= 0 && rect.bottom > maxOverlayBottom) {
              maxOverlayBottom = rect.bottom;
            }
          }
        });
      });

      const topOverlaySelectors = [
        '#essential-announcer',
        '[id*="essential-announcer"]',
        '[class*="essential-announcer"]',
        '[class*="EssentialAnnouncer"]',
        'iframe[id*="essential"]',
        'iframe[class*="essential"]',
        '.essential-announcement-bar',
      ];

      topOverlaySelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((element) => {
          const styles = window.getComputedStyle(element);
          if ((styles.position === 'fixed' || styles.position === 'sticky') && styles.display !== 'none' && styles.visibility !== 'hidden') {
            const rect = element.getBoundingClientRect();
            if (rect.height > 0 && rect.bottom > maxOverlayBottom && rect.top <= 0) {
              maxOverlayBottom = rect.bottom;
            }
          }
        });
      });

      return Math.max(0, Math.floor(maxOverlayBottom));
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.boundUpdateHeaderMetrics) {
        window.removeEventListener('resize', this.boundUpdateHeaderMetrics);
      }
      if (this._onBreakpointChange) {
        window.matchMedia('(max-width: 990px)').removeEventListener('change', this._onBreakpointChange);
      }
      if (this._headerResizeObserver) {
        this._headerResizeObserver.disconnect();
      }
    }

    /**
     * Document-space bounds (same idea as the first IntersectionObserver frame, but stable when
     * the header height changes e.g. “reduce logo size” — avoids scroll threshold flicker).
     */
    refreshHeaderBounds() {
      if (!this.header) return;
      let top = 0;
      for (let node = this.header; node; node = node.offsetParent) {
        top += node.offsetTop;
      }
      this.headerBounds = {
        top,
        bottom: top + this.header.offsetHeight,
      };
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
